// source: system/application/views/survey/survey.php


$(() => {
    if (WebPageObj.survey && WebPageObj.surveyRefresh) {
        setTimeout(() => {
            window.location = window.location.origin;
        }, 3000);
    }
});